export enum Client {
    graph = 'graph',
    exchangeSubgraph = 'exchangeSubgraph',
    lazpad = 'lazpad',
    agent = 'agent',
    pump = 'pump',
}

export enum PadType {
    CAP = 'CAP',
    NO_CAP = 'NO_CAP',
}

export enum PadStatus {
    PREPARE = 'Prepare',
    DEPOSIT = 'Deposit',
    SALE_ENDED = 'SaleEnded',
    LAUNCH = 'Launch',
}

export enum TaskTemplateId {
    INTERACT_WITH_LAUNCH_PAD_AI = 'interactWithLaunchPadAI',
    LAUNCH_PAD = 'launchPadParticipant',
    TWITTER_FOCUS_LAZ_AI = 'twitterFocusLazAI',
    TWITTER_FOCUS_LAZ_PAD = 'twitterFocusLazpad',
    TG_GROUP_JOIN_LAZ_AI = 'tgGroupJoin',
    TG_LAUNCHPAD_GROUP_JOIN = 'tgLaunchpadGroupJoin',
    SHARE_LAUNCH_PAD_PROJECT = 'shareLaunchPadProject',
    INVITED_FRIENDS_COMPLETE = 'invitedFriendsComplete',
    JOIN_LAZBUBU_WHITELIST = 'joinLazbubuWhitelist',
    INVITED_USER_REWARD = 'invitedUserReward',
}

export const TasksDetails = {
    [TaskTemplateId.INTERACT_WITH_LAUNCH_PAD_AI]: {
        title: 'Interact with AI Bot',
        description: '',
    },
    [TaskTemplateId.LAUNCH_PAD]: {
        title: 'Launchpad Participation',
        description: 'Earn PT based on your METIS participation amount.',
    },
    [TaskTemplateId.TWITTER_FOCUS_LAZ_AI]: {
        title: 'Follow LazAI on Twitter',
        description: '',
    },
    [TaskTemplateId.TWITTER_FOCUS_LAZ_PAD]: {
        title: 'Follow LazPad on Twitter',
        description: '',
    },
    [TaskTemplateId.TG_GROUP_JOIN_LAZ_AI]: {
        title: 'Join our Telegram group',
        description: '',
    },
    [TaskTemplateId.TG_LAUNCHPAD_GROUP_JOIN]: {
        title: 'Join Telegram',
        description:
            'Become an active member of the Lazpad or partner project communities.',
    },
    [TaskTemplateId.SHARE_LAUNCH_PAD_PROJECT]: {
        title: 'Share Project on X.com',
        description: 'Share Lazpad project details to your X.com followers.',
    },
    [TaskTemplateId.INVITED_FRIENDS_COMPLETE]: {
        title: 'Invite 3 friends who complete Twitter follow tasks',
        description: 'Invite 3 friends who complete Twitter follow tasks',
    },
    [TaskTemplateId.JOIN_LAZBUBU_WHITELIST]: {
        title: 'Join Lazbubu Whitelist',
        description: '',
    },
    [TaskTemplateId.INVITED_USER_REWARD]: {
        title: 'Invited User Reward',
        description: '',
    },
};

export enum INVESTMENT_STATUS {
    WAIT_FOR_ALLOCATION = 'WAIT_FOR_ALLOCATION',
    WAIT_FOR_DISTRIBUTION = 'WAIT_FOR_DISTRIBUTION',
    WAIT_FOR_CLAIM = 'WAIT_FOR_CLAIM',
    HAS_CLAIMED = 'HAS_CLAIMED',
    WAIT_FOR_EMERGENCY_WITHDRAW = 'WAIT_FOR_EMERGENCY_WITHDRAW',
    HAS_EMERGENCY_WITHDRAW = 'HAS_EMERGENCY_WITHDRAW',
}

export enum Rarity {
    Common = 'Common',
    Advanced = 'Advanced',
    Rare = 'Rare',
    Epic = 'Epic',
}
